'use client';

import { memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type TagProps = {
  children: ReactNode;
  className?: string;
};

export const Tag = memo(({ children, className }: TagProps) => (
  <span className={cn('rounded-16 bg-neutral-4 px-2 py-1 font-medium text-12 text-neutral-11', className)}>
    {children}
  </span>
));

Tag.displayName = 'Tag';
